import loadGPT from './gpt-loader';

export default class AdManager {
  constructor(window) {
    this.slots = [];

    if (window) {
      this.window = window;
    }

    this.GPTLoaded = loadGPT(window);
    this.queue = Promise.resolve();
    return this;
  }

  log(message) {
    console.log(message, ...Array.prototype.slice.call(arguments, 1));

    return this;
  }

  add(...newSlots) {
    this.slots = this.slots.concat.apply(this.slots, newSlots);
    this.queue = Promise.all([this.GPTLoaded, this.queue]).then(
      ([googletag]) => {
        this.log('Adding slots');
        [].concat
          .apply([], newSlots)
          .filter(this.validSlot)
          .forEach(slot => {
            this.log(`Adding slot ${slot.id}`);

            const isOutOfPageSlot = this.isOutOfPageSlot(slot);
            const { adUnit, id, sizes = 'fluid', sizeMap } = slot;
            this.log(
              `Defining${
                isOutOfPageSlot ? ' Out of Page' : ''
              } Slot '${adUnit}' > '${id}'`,
              isOutOfPageSlot ? [] : sizes
            );

            let GPTSlot = isOutOfPageSlot
              ? googletag.defineOutOfPageSlot(adUnit, id)
              : googletag.defineSlot(adUnit, sizes, id);

            if (!GPTSlot) {
              this.log(
                `Error registering ad slot ${id} with GPT. Maybe already defined?`
              );
              return;
            }

            GPTSlot = GPTSlot.addService(googletag.pubads());

            if (Array.isArray(sizeMap) && sizeMap.length > 0) {
              // build GPT Size maps and defaults
              let GPTSizeMap = googletag.sizeMapping();

              sizeMap.forEach(({ breakpoint, sizes }) => {
                GPTSizeMap = GPTSizeMap.addSize(breakpoint, sizes);
              });

              GPTSizeMap = GPTSizeMap.build();

              // and finally add it altogether
              GPTSlot = GPTSlot.defineSizeMapping(GPTSizeMap);
            }

            // Set the normal static, slot-specific, slot-level targeting
            Object.entries(slot.targeting || {})
              .filter(([key, value]) => !!value)
              .forEach(([key, value]) => {
                this.log(`${slot.id} targeting: ${key}=>${value}`);
                GPTSlot.setTargeting(String(key), value);
              });
          });
        this.log('Slots added');
      }
    );
    return this;
  }

  remove() {
    this.log('Removing slots');
    this.slots = [];
    this.queue = this.GPTLoaded.then(googletag => {
      googletag
        .pubads()
        .getSlots()
        .forEach(slot => {
          this.log(`Clear slot level targeting for ${slot.getSlotElementId()}`);
          slot.clearTargeting();
        });

      googletag.destroySlots();
    });
    return this;
  }

  render() {
    let count = 0;
    const consentSetInterval = setInterval(() => {
      // Bail if we haven't got a consent response after the desired number of seconds.
      if (count === (60 * 1000) / 100) {
        clearInterval(consentSetInterval);
      }
      // Check if window._tcfapi has been set
      /* istanbul ignore else */
      if (typeof window.__tcfapi !== 'undefined') {
        clearInterval(consentSetInterval);
        // Set up an event listener so that whenever consent is loaded or updated, we load the ads.
        window.__tcfapi('addEventListener', 2, (tcData, listenerSuccess) => {
          /* istanbul ignore else */
          if (
            listenerSuccess &&
            ['tcloaded', 'useractioncomplete'].includes(tcData.eventStatus)
          ) {
            this.queue = Promise.all([this.GPTLoaded, this.queue]).then(
              ([googletag]) => {
                this.slots.forEach(slot => {
                  googletag.display(slot.id);
                });
                this.log('Calling ad server');
                googletag.pubads().refresh();
              }
            );
            return this;
          }
        });
      }
      count++;
    }, 100);
  }

  setPageTargeting(targeting) {
    this.queue = Promise.all([this.GPTLoaded, this.queue]).then(
      ([googletag]) => {
        Object.entries(targeting)
          .filter(([key, value]) => !!value)
          .forEach(([key, value]) => {
            const k = String(key);
            if (
              googletag
                .pubads()
                .getTargetingKeys()
                .indexOf(k) >= 0
            ) {
              googletag.pubads().clearTargeting(k);
            }
            this.log(`Setting page targeting: ${k}=>${value}`);
            googletag.pubads().setTargeting(k, value);
          });
      }
    );
    return this;
  }

  clearPageTargeting() {
    this.queue = Promise.all([this.GPTLoaded, this.queue]).then(
      ([googletag]) => {
        this.log('Clear page targeting');
        googletag.pubads().clearTargeting();
      }
    );
    return this;
  }

  validSlot(slot) {
    let errors = false;
    if (!slot.id) {
      this.log(`Missing ad slot id from ${slot}`);
      errors = true;
    }
    if (!slot.adUnit) {
      this.log(`Missing adUnit from slot ${slot.id}`);
      errors = true;
    }
    return !errors;
  }

  isOutOfPageSlot(slot) {
    return 'outOfPage' in slot && slot.outOfPage;
  }

  then() {
    this.queue = this.queue.then.apply(this.queue, arguments);
    return this;
  }

  catch() {
    this.queue = this.queue.catch.apply(this.queue, arguments);
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/ads/ad-manager.js